import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUserInvoicingParameters } = getCRUDHooks({
  entityName: 'userInvoicingParameter',
  get: ({ userId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).invoicingParameters.get(),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUserInvoicingParameters,
};
